
define('text!templates/modules/setting/business/modals/payment-finish-process-modal.html',[],function () { return '<p class="text-center">Please wait while we are saving your payment method.&nbsp<span class="fa fa-spinner fa-pulse fa-1x fa-fw"></span>\n</p>\n';});

